import { LayoutProps } from "common/Layout/types/Layout.types";
import { FC } from "react";
import { fetchLayoutData } from "../../lib";
import Meta from "Components/Meta";
import FourOFour from "Features/404";

type Props = {
  menus: LayoutProps;
};

function Error({ statusCode }: any) {
  return (
    <p>
      {statusCode ? (
        statusCode === 404 ? (
          <>
            <Meta />
            <FourOFour />
          </>
        ) : (
          `An error ${statusCode} occurred on server`
        )
      ) : (
        "An error occurred on client"
      )}
    </p>
  );
}

Error.getInitialProps = ({ res, err }: any) => {
  const statusCode = res ? res.statusCode : err ? err.statusCode : 404;

  // Only set cache header if not already set
  if (res?.getHeader && !res.getHeader("Cache-Tag")) {
    res.setHeader(
      "Cache-Tag",
      `tindle_${process.env.NEXT_PUBLIC_ENV_STATE}, ${statusCode}`,
    );
  }

  return { statusCode };
};

export default Error;
